// #region imports

// --- Angular
import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy, OnDestroy, SimpleChange, SimpleChanges, OnChanges } from '@angular/core';

// --- RxJs
import { Observable, Subscription } from 'rxjs';

// --- 3rd Party
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

// --- HS Code
import { TermsAndConditionsModel } from '../../../models';
import { TermsAndConditionsBaseService } from '../../../core/services';

// #endregion
@Component({
  selector: 'hs-policy-nav-links',
  templateUrl: './policy-nav-links.component.html',
  styleUrls: ['./policy-nav-links.component.scss']
})
export class PolicyNavLinksComponent implements OnChanges {
  @Input() labelText: string = '';

  @Output() showPrivacyPolicy = new EventEmitter();
  @Output() showTermsAndConditions = new EventEmitter();

  text1: string = '';
  text2: string = '';
  text3: string = '';
  text4: string = '';
  text5: string = '';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes['labelText'] && changes['labelText'].currentValue) {
      let theText = changes['labelText'].currentValue;
      let terminator = theText.indexOf('<');
      this.text1 = theText.substring(0, terminator);
      let initiator = theText.indexOf('>') + 1;
      terminator = theText.indexOf('<', initiator + 1);
      this.text2 = theText.substring(initiator, terminator);
      initiator = theText.indexOf('>', terminator + 1) + 1;
      terminator = theText.indexOf('<', initiator + 1);
      this.text3 = theText.substring(initiator, terminator);
      initiator = theText.indexOf('>', terminator + 1) + 1;
      terminator = theText.indexOf('<', initiator + 1);
      this.text4 = theText.substring(initiator, terminator);
      initiator = theText.indexOf('>', terminator + 1) + 1;
      this.text5 = theText.substring(initiator);
    }
  }

  showPrivacy(e: any): void {
    e.preventDefault();
    this.showPrivacyPolicy.emit();
  }

  showTerms(e: any): void {
    e.preventDefault();
    this.showTermsAndConditions.emit();
  }
}
